var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 13.4483,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4483C0 6.02099 6.021 0 13.4483 0H46.5517C53.979 0 60 6.021 60 13.4483V20.1724H0V13.4483Z",
    fill: "#FBAF3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6996 16.1724L20.5727 7.3834H21.6527L25.414 16.1724H24.0237L23.1423 13.9999H18.9589L18.0899 16.1724H16.6996ZM19.3809 12.9572H22.7078L21.0692 8.92271H21.0444L19.3809 12.9572ZM26.396 7.3834H27.5877V12.771C27.5877 13.8634 28.1339 15.2786 29.7974 15.2786C31.4608 15.2786 32.007 13.8634 32.007 12.771V7.3834H33.1987V12.9572C33.1987 14.9931 31.7215 16.3958 29.7974 16.3958C27.8732 16.3958 26.396 14.9931 26.396 12.9572V7.3834ZM39.6428 11.2565H42.7835V15.5889C41.9269 16.1103 40.5241 16.3958 39.4566 16.3958C36.4773 16.3958 34.7517 14.2731 34.7517 11.7779C34.7517 9.17098 36.651 7.15995 39.3324 7.15995C40.9462 7.15995 41.9269 7.59443 42.6097 8.30202L41.7655 9.20823C41.0455 8.51305 40.2138 8.27719 39.3324 8.27719C37.3214 8.27719 36.0179 9.85374 36.0179 11.7779C36.0179 13.7641 37.4952 15.2786 39.4317 15.2786C40.2635 15.2786 41.0579 15.1172 41.5917 14.8193V12.3737H39.6428V11.2565Z",
    fill: "#060200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6187 41.2711L24.0815 40.8221C24.4146 41.8069 24.878 42.2849 25.9642 42.2849C27.036 42.2849 27.9484 41.5318 27.9484 40.4311C27.9484 38.7221 26.3697 38.5194 25.0663 38.5194V37.3028C27.1808 37.3028 27.6877 36.709 27.6877 35.6952C27.6877 34.609 26.9491 34.0297 25.9642 34.0297C25.2111 34.0297 24.5594 34.5076 24.2553 35.2173L22.836 34.7394C23.3718 33.4359 24.5739 32.8132 25.9353 32.8132C27.6153 32.8132 29.078 33.7111 29.078 35.6083C29.078 36.6801 28.3684 37.6214 27.3256 37.9256V37.9545C28.6146 38.1718 29.3387 39.2725 29.3387 40.5325C29.3387 42.5021 27.7311 43.5014 25.9208 43.5014C24.3566 43.5014 23.0822 42.8207 22.6187 41.2711ZM33.9104 43.3276V34.6669L32.0276 36.4049L31.2166 35.4345L34.0697 33.0738H35.3007V43.3276H33.9104Z",
    fill: "#060200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.e916be310562478829c53a73dc1185e3.svg";
export { ForwardRef as ReactComponent };